var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"public-portfolio-recommended-users-section"},_vm._l((_vm.topUsers),function(user){return _c('PublicPortfolioRecommendedUser',{key:user.id,attrs:{"name":user.auto_name,"image":user.avatar_url,"company":user.current_company,"position":user.position,"slug":user.slug}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }